<script setup lang="ts">
/**
 * Account secured (Figma `3606:68891`). Every session is signed out, so it
 * ends on Log in, like Password updated.
 */
import { useI18n } from 'vue-i18n'
import { FairButton } from '@/ui/primitives/FairButton'
import { useAuthModal } from '@/features/auth/store'
import AuthScreenShell from '@/features/auth/ui/parts/AuthScreenShell.vue'
import successUrl from '@/assets/img/auth/illustration-password-updated.png'

const { t } = useI18n()
const authModal = useAuthModal()
</script>

<template>
  <AuthScreenShell
    centered
    :title="t('email_links.secured.title')"
    :description="t('email_links.secured.description')"
  >
    <template #art>
      <img
        class="fair-auth-screen__art"
        :src="successUrl"
        alt=""
      >
    </template>

    <FairButton
      class="fair-auth-cta"
      size="auto"
      :label="t('auth.password_updated.login_cta')"
      @click="authModal.showAuthModal('login')"
    />
  </AuthScreenShell>
</template>
